<template>
    <div>
    <!--- Nav Bar main --->
    <nav-bar-main></nav-bar-main>

    <nav-bar-dispositivi  v-if="plantDetails != null" class="animated fadeIn container-fluid"></nav-bar-dispositivi>
 
        <div v-if="plantDetails != null && collectionDetails !=null"  class="animated fadeIn container-fluid">
            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
                <div>
                
                <!-- navbar dei comandi visibile solo se admin o installatore o collaboratore -->
                <b-row v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" class="fixed-top navbar-command">
                    <b-col lg="12" md="12">

                    <!-- banner error on plant -->
                    <div v-if="error != null" class="alert alert-danger" role="alert">
                        {{$t(error)}}
                    </div>

                    <!-- banner per basic plant -->
                    <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro/>
                    </b-alert>
                    
                    <!-- banner per pro expired -->
                    <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
                        <banner-pro-expired/>
                    </b-alert>
                
                    <!--- Loader per il caricamento pagina o invio dei comandi -->
                    <Loader/>

                    <!-- barra dei comandi -->
                    <b-row v-if="!$store.state.loading" class="pull-left ml-4" style="width: 100%">
                            <add-collection collection=""> </add-collection>                          
                            <div id="navbar-search">
                                <div id="navbar-filter" v-if="!advancedFilters">     
                                        <b-input-group>
                                            <b-form-input type="text" placeholder="Cerca" v-model="filters.search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i> </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                </div>
                            </div>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </show-at>

            <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="small">
                <div>
                    <b-nav class="mobile-sub-nav fixed-top">
                        <!--<b-button size="sm" v-b-toggle.commands-collapse>+</b-button>-->
                        <b-nav-text style="padding-left:16px"> {{$t("navbar_dispositivi.button_centrali")}}</b-nav-text>
                        <!--<b-dropdown id="dd-centrali-menu" right no-caret >
                            <template v-slot:button-content>
                            <i class="fa fa-bars fa-lg"></i>
                            </template>
                            <b-dropdown-item class="active">{{$t("navbar_dispositivi.button_centrali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantgeneral/'+ this.$store.state.currentPlant.id}" >{{$t("navbar.settings_generali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantusers/'+ this.$store.state.currentPlant.id}">{{$t("navbar.settings_utenti")}}</b-dropdown-item>
                        </b-dropdown>-->
                    </b-nav>
                </div>
            </show-at>

             <!-- Tabella collections -->
            <div v-if="tableData" style="margin-top:125px">
           
            <b-list-group v-for="item in tableData" v-bind:key="item.collectionId">
              <b-list-group-item class="mb-2 mt-1"> 
                <b-row>
                    <b-col cols="11">
                        <h5 class="mb-2 ml-1">{{item.collectionName}}</h5>
                    </b-col>
                    <b-col cols="1">
                        <b-row>
                            <b-button><i class="fas fa-trash-alt" style="color:#0090CD" @click="removeCollection(item)"></i></b-button>
                            <edit-collection :collection="item"> </edit-collection>
                        </b-row>
                    </b-col>        
                </b-row>
                <small>{{item.collectionType.toUpperCase()}}</small>
              </b-list-group-item>
            </b-list-group>

            </div>


        </div>

    </div>    

</template>

<script>

import Vue from 'vue'
import {ClientTable, Event} from 'vue-tables-2'
Vue.use(ClientTable)

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import AddCollection from '@/components/AddCollection'
import EditCollection from '@/components/EditCollection'
import CreaAggregazione from '@/components/CreaAggregazione'
import {showAt, hideAt} from 'vue-breakpoints'
import BannerPro from '@/components/BannerPro'
import BannerProExpired from '@/components/BannerProExpired'

import { mapState } from 'vuex';


export default {
    name: 'DispositiviImpianto',
    components: {
        NavBarMain,
        NavBarDispositivi,
        AddCollection,
        EditCollection,
        CreaAggregazione,
        BannerPro,
        BannerProExpired,
        Event,
        hideAt, 
        showAt 
    },
    props: ['plantId'],
    data() {
        return {
            cuToRemove: null,
            modalRemoveCuVisible: false,
            cuGroups:null,
            cuAdvanced:null,
            modalGroupsCuVisible:false,
            modalAdvancedCuVisible:false,
            advancedFilters: false,
            filters: {
                search: '',
                idCent: '',
                nomeCent: '',
                idLamp: '',
                nomeLamp: '',
                tipoCent: ['all'],
                tipoLamp: 'all',
                autonomia: ['all'],
                parita: 'all',
                infinity: 'all',
                rete_se:'all'
            },
            selectedGroup: '',
            groups: Array.from([,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]),
            alerts: [],
            validation_alerts: [],
            currentCent: null,
            currentLamp: null,
            status: 'none_selected',
            headerClose: true,
            
            loop: 0,
        }     
    
    },

    computed: {
        ...mapState(['loading','error','commandsPending', 'commandResponse']),
      
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null)  {
                this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        collectionDetails(){
            this.tableData=this.$store.state.plantCollections;
            console.log("Collections: ",this.tableData);
            return this.tableData;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        }, 
        numUnits() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0)  return 0;
            return this.unitsDetails.length;
        },
        totalLamps() {


            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            return this.unitsDetails.reduce(function(total,u){
                //return total + ((u.lamps_id == null) ? 0 : u.lamps_id.length);
                if(u.cu_type=="cablecom")
                    return total + (u.num_lamp_found | 0);
                else
                    return total + (u.num_lamp_present | 0);
            },0); 
            
        },
    },
    mounted() {
        console.log("mounted",this.plantDetails);
        if (this.plantDetails!=null && this.collectionDetails==null) 
               this.$store.dispatch('loadPlantCollections', this.plantId);               
    },
    updated() {
        if (this.plantDetails!=null && this.collectionDetails==null) 
               this.$store.dispatch('loadPlantCollections', this.plantId);  
    },
    watch: {
        loading(val,oldval) {
            console.log("aggregazioni loading changed:" + val+", error=" + this.error+", loop=" + this.loop);
            //if (this.loop > 50) return;
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.$store.state.commandResponse.pending == false && this.$store.state.commandResponse.command != null && this.$store.state.commandResponse.error != "") {
            }
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
            console.log("Ruolo utente", this.$store.state.user.usertype);
        },
        commandResponse(val, oldval) {
            console.log("cambiata commandResponse ->", val);
            let resp = val; 
            console.log("analizzo la risposta, loop= " + this.loop  , resp);
            if (!resp.pending && resp.command != null) {
                    if (resp.error != null && resp.error != "") {
                        console.log("resp error",resp.error);
                        var alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: "Resp error"
                        }  
                        this.alerts.push(alert);  
                    } else {
                        console.log("risposta ok per comando " + resp.command + ", cu:" + resp.cu);
                        switch (resp.command) {
                                case 'saveCollection':
                                     this.$store.dispatch('loadPlantCollections', this.plantId);  
                                    break;
                                case 'updateCollection': 
                                    //let coll = this.tableData.filter(coll => coll.collectionId == resp.response.collectionInfo.collectionId);
                                    //if (coll != null) coll.
                                    for (var i=0; i< this.tableData.length; i++) {
                                        var coll = this.tableData[i];
                                        if (coll.collectionId == resp.response.collectionInfo.collectionId) {
                                            this.tableData[i] = resp.response.collectionInfo;
                                            //console.log("aggiornata collection");
                                            
                                            this.$forceUpdate();
                                            break;
                                        }
                                    }
                                    break;
                                case 'removeCollection':
                                    for (var i=0; i< this.tableData.length; i++) {
                                        var coll = this.tableData[i];
                                        if (coll.collectionId == resp.response.collectionInfo.collectionId) {
                                            this.tableData.splice(i,1);
                                            this.$forceUpdate();
                                            break;
                                        }
                                    }
                                    break;
                            }
                        }

                    }
        }
    },
    methods: {
        removeCollection(collection)
        {
            console.log("Remove collection: ",collection);
            let self = this;
            this.$bvModal.msgBoxConfirm("Eliminare questa aggregazione?", {
                        title: 'Conferma',
                        okVariant: 'danger',
                        okTitle: 'ELIMINA',
                        cancelTitle: 'ANNULLA',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                            self.$store.dispatch("dbRemoveCollection", {
                                plantId: self.$store.state.currentPlant.id,
                                collectionId: collection.collectionId,
                            });
                        }
                    });

            
        },
        filtra() {
            let self = this;
            if (!this.advancedFilters) {
                //filtro semplice
                let fltArr = this.filters.search.trim().toLowerCase().split(",",-1);
                console.log("filtro semplice:", fltArr);
                
                if (this.filters.search.trim() == '') {
                    this.allTableData.forEach(cent => {
                        
                        if (cent.lamps != null && cent.lamps.length > 0) {
                            cent.lamps.forEach(lamp => {
                                lamp['visible'] = true;
                            });
                        }
                    });
                    this.tableData = this.allTableData;
                } else {
                    this.tableData = this.allTableData.filter(cent => {
                        console.log("cent:",cent);
                        
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_id == flt) || (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                if (cent.lamps != null && cent.lamps.length > 0) {
                                    cent.lamps.forEach(lamp => {
                                        lamp['visible'] = true;
                                    });
                                } 
                                break;
                            }
                            if (cent.lamps != null && cent.lamps.length > 0) {
                                    cent.lamps.forEach(lamp => {
                                        if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt)) {
                                            lamp['visible'] = true;
                                            found = true;
                                        } else {
                                            lamp['visible'] = false;
                                        }
                                    });
                            }
                            if (found) {
                                match = true;
                                break;
                            } 
                        }
                        return match;
                    });
                    console.log("tableData:",this.tableData);
                }


            } else {
                console.log("filtri avanzati:",this.filters);
                this.tableData = this.allTableData.filter(cent => {
                    console.log("cent:",cent);
                    var centOk = true;
                    //filtri su centrale
                    if (self.filters.idCent.trim() != '') {
                        let fltArr = self.filters.idCent.trim().toLowerCase().split(',',-1);
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_id == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                break;
                            }
                        }
                        if (! match) centOk = false;
                    } 
                    if (centOk && self.filters.nomeCent.trim() != '') {
                        let fltArr = self.filters.nomeCent.trim().toLowerCase().split(',',-1);
                        var match = false;
                        for (var f = 0; f < fltArr.length; f++) {
                            let flt = fltArr[f].trim();
                            var found = (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found) {
                                match = true;
                                break;
                            }
                        }
                        if (! match) centOk = false;
                    } 
                    if (centOk && self.filters.tipoCent.length>0 && self.filters.tipoCent[0] != 'all') {
                        var found = false;
                        self.filters.tipoCent.forEach(tipoCent => {
                            if (cent.cu_type == tipoCent) found = true;
                        });
                        if (!found) centOk = false;
                    }
                    //filtri su lampade
                    if (centOk && cent.lamps != null && cent.lamps.length > 0) {
                        var oneLampVisible = false;
                        cent.lamps.forEach(lamp => {
                            var visible = true;
                            
                            if (self.filters.idLamp.trim() != '') {
                                let fltArr = self.filters.idLamp.trim().toLowerCase().split(',',-1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++) {
                                    let flt = fltArr[f].trim();
                                    var found = (lamp.id.toLowerCase() == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                                    if (found) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (! match) visible = false;
                            } 
                            if (visible && self.filters.nomeLamp.trim() != '') {
                                let fltArr = self.filters.nomeLamp.trim().toLowerCase().split(',',-1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++) {
                                    let flt = fltArr[f].trim();
                                    var found = (lamp.desc || '').toLowerCase().includes(flt);
                                    if (found) {
                                        match = true;
                                        break;
                                    }
                                }
                                if (! match) visible = false;
                            } 
                            if (visible && self.filters.tipoLamp != 'all') {
                                if (self.filters.tipoLamp == 'oxy' && lamp.sanificaaria != true) {
                                    visible = false;
                                } else if (self.filters.tipoLamp != 'oxy' && lamp.sanificaaria == true) {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SA' && lamp.lamp_type != 'SA') {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SE' && lamp.lamp_type != 'SE') {
                                    visible = false;
                                }
                            }
                            if (visible && self.filters.rete_se != 'all') {
                                if (self.filters.rete_se == 'SE_ON' && lamp.emer_active != 'NO') {
                                    visible = false;
                                } else if (self.filters.rete_se == 'SE_OFF' && lamp.emer_active == 'NO') {
                                    visible = false;
                                }
                            }
                            if (visible && self.filters.autonomia.length >0 && self.filters.autonomia[0] != 'all') {
                                var found = false;
                                self.filters.autonomia.forEach(aut => {
                                    if (lamp.autonomy == aut) found = true;
                                });
                                if (!found) visible = false;
                            }
                            if (visible && self.filters.parita != 'all') {
                                if (lamp.parity != self.filters.parita) visible = false;
                            }
                            if (visible && self.filters.infinity != 'all') {
                                if (lamp.lssa != self.filters.infinity) visible = false;
                            }
                            if (visible) oneLampVisible = true;
                            lamp['visible'] = visible;
                        });
                        if (!oneLampVisible) centOk = false;
                    }
                    if (centOk && (cent.lamps == null || cent.lamps.length == 0)) {
                        if (self.filters.idLamp.trim() != '' || self.filters.nomeLamp.trim() != '' || self.filters.tipoLamp != 'all' || self.filters.parita != 'all' || self.filters.infinity != 'all' || self.filters.rete_se != 'all' || (self.filters.autonomia.length > 0 && self.filters.autonomia[0] != 'all')) {
                            centOk = false;
                        } 
                    }

                    return centOk;
                });
                console.log("tableData:",this.tableData);
            }

            if (this.selectedGroup != "") {
                let self = this;
                let sg = parseInt(this.selectedGroup);
                console.log("devo filtrare anche per gruppo " + this.selectedGroup);
                this.tableData = this.tableData.filter(cent => {
                        //console.log("cent:",cent);
                        if (cent.cu_type == 'cablecom' || cent.lamps == null || cent.lamps.length == 0) return false;
                        var lampGroups = cent.lamps.filter((lamp) =>{
                            if (lamp.groups == null || lamp.groups.length == 0) return false;
                            return lampGroups=lamp.groups.includes(sg);
                        })
                        console.log("filtr centrale " + cent.cu_id+" lamp groups:",lampGroups);
                        for(var i=0;i<this.tableData.length;i++)
                        {
                           if(this.tableData[i].cu_id==cent.cu_id)
                           {
                              for(var k=0;k<this.tableData[i].lamps.length;k++)
                              {
                                  this.tableData[i].lamps[k]['visible']=false
                              }
                           }
                        }

                        for(var i=0;i<lampGroups.length;i++)
                        {
                            lampGroups[i]['visible']=true;
                        }
                        
                        return (lampGroups != null && lampGroups.length > 0);
                });
            }

        },
        clearFilters() {
            this.filters = {
                    search: '',
                    idCent: '',
                    nomeCent: '',
                    idLamp: '',
                    nomeLamp: '',
                    tipoCent: ['all'],
                    tipoLamp: 'all',
                    autonomia: ['all'],
                    rete_se:'all',
                    parita: 'all',
                    infinity: 'all'
                };
            this.filtra();
        },
        showFilters() {
            console.log("mostro filtri avanzati");
            this.advancedFilters = true;
            this.clearFilters();
            
        },
        hideFilters() {
            console.log("nascondo filtri avanzati");
            this.advancedFilters = false;
            this.clearFilters();
        },
        onDecode(decodedString) {
            console.log("codeScanned:",decodedString);
            this.qrScanned = decodedString;
          //setTimeout(function() {
            this.scanning = false;
          //},2000);
          
        },
      
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "?";
        },
        passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        },
        toggleLamps(cu_id) {
            this.$root.$emit('bv::toggle::collapse', 'collapse-'+cu_id)
        },
       
       
    }
}
</script>